<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">
            Última Execução
            {{ rotina ? rotina.titulo : "" }}
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-hover" style="margin-left: auto; margin-right: auto;">
            <thead>
            <tr>
              <th>Chave</th>
              <th>Valor</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="column in columns">
              <td>{{ column.label }}</td>
              <td style="word-wrap: break-word;">{{ column.value }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yesNoRepresentation } from "@/helpers/transformers";
import {get} from "@/helpers/apiRequest";
import { CRONS } from "../constantes";

export default {
  name: "UltimaRotina",
  props:[
    "rotina",
  ],
  data() {
    return {
      rotinaLog: {},
      columns: [],
      crons: CRONS,
    }
  },
  methods: {
    fillColumns() {
      this.columns = [
        { label: "ID", value: this.rotina.id },
        { label: "Título", value: this.rotina.titulo },
        { label: "Descrição", value: this.rotina.descricao },
        { label: "Observação", value: this.rotina.observacao ?? "Sem observação" },
        { label: "Script", value: this.rotina.script },
        { label: "Ativo", value: yesNoRepresentation(this.rotina.ativo) },
        { label: "Modo", value: this.rotina.tipo_execucao === "M" ? "Manual" : "Automático" },
        { label: "Intervalo", value: this.rotina.tipo_execucao === "A" ? this.humanCron(this.rotina.cron) : "N/A" },
        { label: "Data de criação", value: this.rotina.datahora_criacao },
        { label: "Última alteração", value: this.rotina.datahora_atualizacao },
        { label: "Sucesso", value: this.rotinaLog?.sucesso != null ? yesNoRepresentation(this.rotinaLog.sucesso) : "N/A" },
        { label: "Mensagem", value: this.rotinaLog?.mensagem_retorno ?? "N/A" },
        { label: "Tempo de execução", value: this.rotinaLog?.tempo_execucao ? `${this.rotinaLog.tempo_execucao} seg` : "N/A" },
        { label: "Início", value: this.rotinaLog?.dthora_inicio ?? "N/A" },
        { label: "Fim", value: this.rotinaLog?.dthora_fim ?? "N/A" }
      ];
    },
    humanCron(cron) {
      return this.crons[cron] || cron;
    },
    getLogs(page = 1) {
      this.isFetching = true;
      this.errorMessage = null;

      get(`/admin/rotinas/log-execucao/${this.rotina.id}?page=${page}`)
        .then((response) => {
          this.rotinaLog = response.itens[0];
          this.fillColumns();
        })
        .catch((error) => this.errorMessage = error.message)
        .finally(() => {
          this.isFetching = false;
        })
    },
  },
  beforeMount() {
    this.getLogs(1);
  },
}
</script>

<style scoped>

</style>